import { Alert, AlertDescription } from './alert';
import { AlertCircle } from 'lucide-react';
import { getErrorMessage } from '../lib/error-handler';

interface ErrorAlertProps {
  error: unknown;
  className?: string;
}

/**
 * Reusable error alert component
 * Automatically extracts user-friendly messages from API errors
 * 
 * Usage:
 * const [error, setError] = useState<unknown>(null);
 * <ErrorAlert error={error} />
 */
export function ErrorAlert({ error, className }: ErrorAlertProps) {
  if (!error) return null;

  return (
    <Alert variant="destructive" className={className}>
      <AlertCircle className="h-4 w-4" />
      <AlertDescription>{getErrorMessage(error)}</AlertDescription>
    </Alert>
  );
}
